// extracted by mini-css-extract-plugin
module.exports = {"TableNumber":"TableNumber_TableNumber__t9TL6","TableNumber__icon":"TableNumber_TableNumber__icon__olkg5"};